export const ENGAGEMENT_EVENTS = {
  audioPlayed: 'engagement_audio_played',
  translationToggled: 'engagement_translation_toggled',
  exampleCopied: 'engagement_example_copied',
  scrollDepth: 'engagement_scroll_depth',
  cardHovered: 'engagement_card_hovered',
  offlineInfoPressed: 'engagement_offline_info_pressed',
  widgetOpened: 'engagement_widget_opened',
} as const;

export type EngagementEventNameType = (typeof ENGAGEMENT_EVENTS)[keyof typeof ENGAGEMENT_EVENTS];
